var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    // Avoid destructuring and optional-chaining here: this function
	                    // is serialized as a string by mini-css-extract-plugin and
	                    // injected directly into the browser bundle without further
	                    // transpilation. Destructuring (`const { x } = obj`) breaks on
	                    // browsers that pre-date ES2015 support (e.g. Chrome <49).
	                    var href = linkTag.href;
	                    var onload = linkTag.onload;
	                    var onerror = linkTag.onerror;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(function() {
	                        if (onload) onload.call(linkTag, {
	                            type: 'load'
	                        });
	                    }, function() {
	                        if (onerror) onerror.call(linkTag, {});
	                    });
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	8068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"85":1,"100":1,"114":1,"242":1,"261":1,"271":1,"279":1,"397":1,"563":1,"645":1,"694":1,"742":1,"797":1,"847":1,"969":1,"1015":1,"1131":1,"1153":1,"1248":1,"1302":1,"1327":1,"1455":1,"1491":1,"1541":1,"1563":1,"1643":1,"1810":1,"1826":1,"1901":1,"1947":1,"1999":1,"2079":1,"2165":1,"2183":1,"2271":1,"2316":1,"2411":1,"2459":1,"2533":1,"2642":1,"2663":1,"2691":1,"2759":1,"2771":1,"2816":1,"2984":1,"3045":1,"3100":1,"3207":1,"3275":1,"3295":1,"3381":1,"3430":1,"3661":1,"3667":1,"3673":1,"3703":1,"3736":1,"3787":1,"3847":1,"3860":1,"3885":1,"3977":1,"3983":1,"4011":1,"4019":1,"4071":1,"4109":1,"4128":1,"4279":1,"4307":1,"4318":1,"4365":1,"4423":1,"4543":1,"4711":1,"4716":1,"4741":1,"4783":1,"4825":1,"4872":1,"4875":1,"4905":1,"4973":1,"5135":1,"5258":1,"5425":1,"5437":1,"5439":1,"5456":1,"5498":1,"5579":1,"5693":1,"5699":1,"5723":1,"5776":1,"5825":1,"5862":1,"5947":1,"6043":1,"6055":1,"6117":1,"6127":1,"6177":1,"6245":1,"6521":1,"6687":1,"6713":1,"6723":1,"6877":1,"6895":1,"7077":1,"7147":1,"7241":1,"7259":1,"7459":1,"7483":1,"7501":1,"7727":1,"7759":1,"7818":1,"7861":1,"7904":1,"7915":1,"7929":1,"7973":1,"7979":1,"7981":1,"8095":1,"8121":1,"8127":1,"8137":1,"8193":1,"8265":1,"8302":1,"8347":1,"8367":1,"8375":1,"8439":1,"8479":1,"8567":1,"8649":1,"8695":1,"8722":1,"8742":1,"8761":1,"8910":1,"8926":1,"8953":1,"9203":1,"9267":1,"9281":1,"9371":1,"9409":1,"9423":1,"9483":1,"9642":1,"9707":1,"9719":1,"9823":1,"9829":1,"9881":1,"9941":1,"9943":1,"9953":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr